import { Component, OnInit } from '@angular/core';
import {GameService} from "../../services/game.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss']
})
export class ExploreComponent implements OnInit {

  games: any[] = [];
  skeletonItems = Array.from({ length: 5 });
  gamesLoaded : boolean = false;
    visibleGames: any[] = [];  // only the 5 being shown
    startIndex = 0;            // where the slider window starts
    displayCount = 5;

    constructor(private gameService: GameService, private router :Router) { }

  ngOnInit(): void {
    this.fetchGames();
  }

    scrollRight() {
        if (this.startIndex + this.displayCount < this.games.length) {
            this.startIndex++;
            this.updateVisibleGames();
        }
    }
    scrollLeft() {
        if (this.startIndex > 0) {
            this.startIndex--;
            this.updateVisibleGames();
        }
    }

  fetchGames() {
    this.gameService.getGames().subscribe(
        (data: any[]) => {
          this.games = data;
          this.gamesLoaded=true;
            this.updateVisibleGames();
          console.log("game4s load3d",data);
        },
        (error) => {
          console.error('Error fetching games:', error);
        }
    );
  }

    updateVisibleGames() {
        this.visibleGames = this.games.slice(this.startIndex, this.startIndex + this.displayCount);
    }

    gameSlug(name: string): string {
        return (name || 'game')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }
}
